import { render, staticRenderFns } from "./LiveMenu.vue?vue&type=template&id=5da3b4e7&scoped=true&"
import script from "./LiveMenu.vue?vue&type=script&lang=js&"
export * from "./LiveMenu.vue?vue&type=script&lang=js&"
import style0 from "./LiveMenu.vue?vue&type=style&index=0&id=5da3b4e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3b4e7",
  null
  
)

export default component.exports